import React from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import withMotion from "../../../Utils/withMotion";

//Pages
import PageNotFound from "../../../404";
import AngelusCastleCobble from "./Pages/AngelusCastleCobble";

const Designs = () => {
  return (
    <div className="container-fluid page-design">
      <Switch>
        <Route
          exact
          component={AngelusCastleCobble}
          path="/styles/style/angelus-castle-cobble"
        />
        <Route exact component={PageNotFound} path="*" />
      </Switch>
    </div>
  );
};

export default withRouter(withMotion(Designs));
